/**
 * Search Tracking Hook
 * Provides easy integration with search analytics tracking
 */

import { useCallback } from 'react';
import { searchAnalytics } from '../services/searchAnalytics';
import { useAuth } from '../context/AuthContext';
import { useSpace } from '../context/SpaceContext';

export const useSearchTracking = () => {
  const { user } = useAuth();
  const { currentSpace } = useSpace();

  const trackSearch = useCallback(
    (
      query: string, 
      resultsCount: number, 
      responseTime: number = 0
    ) => {
      const userId = user?.email || user?.id || 'anonymous';
      const spaceId = currentSpace?.space_id;
      
      // Track the search event
      searchAnalytics.trackSearch(
        query,
        resultsCount,
        responseTime,
        spaceId,
        userId
      );
      
      console.log('🔍 Search tracked:', {
        query: query.substring(0, 50) + (query.length > 50 ? '...' : ''),
        resultsCount,
        responseTime: `${responseTime}ms`,
        space: currentSpace?.name || 'Unknown'
      });
    },
    [user, currentSpace]
  );

  const getSearchAnalytics = useCallback(async () => {
    const userId = user?.email || user?.id;
    return await searchAnalytics.getAnalytics(userId);
  }, [user]);

  const getQuickStats = useCallback(async () => {
    const userId = user?.email || user?.id;
    const analytics = await searchAnalytics.getAnalytics(userId);
    return {
      searchesThisWeek: analytics.searchesThisWeek,
      searchesToday: analytics.searchesToday,
      successRate: analytics.successRate
    };
  }, [user]);

  return {
    trackSearch,
    getSearchAnalytics,
    getQuickStats
  };
}; 